import React, { useEffect, useState } from "react";
import {
  User,
  Smartphone,
  IndianRupee,
  CalendarDays,
  FileText,
  Layers3,
  Plus,
  Trash2,
  X
} from "lucide-react";

import "./SubscriptionModal.css";

const getInitialState = () => ({
  clientName: "",
  type: "Direct",
  whatsappUsername: "",
  sellingRate: "",
  renewalRate: "",
  expiryDate: "",
  remark: "",
  serialNumbers: [""]
});

export default function SubscriptionModal({

  editingSub,
  saving = false,
  onClose,
  onSave

}) {

  const [formData, setFormData] = useState(getInitialState());

  useEffect(() => {

    if (editingSub) {

      setFormData({

        clientName: editingSub.clientName || "",

        type: editingSub.type || "Direct",

        whatsappUsername:
          editingSub.whatsappUsername || "",

        sellingRate:
          editingSub.sellingRate || "",

        renewalRate:
          editingSub.renewalRate || "",

        expiryDate:
          editingSub.expiryDate
            ? editingSub.expiryDate.substring(0,10)
            : "",

        remark:
          editingSub.remark || "",

        serialNumbers:
          editingSub.serialNumbers &&
          editingSub.serialNumbers.length
            ? [...editingSub.serialNumbers]
            : [""]

      });

    } else {

      setFormData(getInitialState());

    }

  }, [editingSub]);

  const updateField = (field,value)=>{

    setFormData(prev=>({

      ...prev,

      [field]:value

    }));

  };

  const updateSerial=(index,value)=>{

    const list=[...formData.serialNumbers];

    list[index]=value;

    updateField("serialNumbers",list);

  };

  const addSerial=()=>{

    updateField(

      "serialNumbers",

      [

        ...formData.serialNumbers,

        ""

      ]

    );

  };

  const removeSerial=(index)=>{

    if(formData.serialNumbers.length===1){

      return;

    }

    updateField(

      "serialNumbers",

      formData.serialNumbers.filter((_,i)=>i!==index)

    );

  };

  const handleSubmit=(e)=>{

    e.preventDefault();

    const serials=formData.serialNumbers

      .map(s=>s.trim())

      .filter(Boolean);

    if(!formData.clientName.trim()){

      alert("Client Name is required.");

      return;

    }

    if(serials.length===0){

      alert("Please add at least one serial number.");

      return;

    }

    onSave({

      ...formData,

      serialNumbers:serials,

      sellingRate:Number(formData.sellingRate)||0,

      renewalRate:Number(formData.renewalRate)||0

    });

  };

  return(

    <div className="modal-overlay">

      <div className="subscription-modal">

        <div className="modal-header">

          <div>

            <h2>

              {

                editingSub

                ?

                "Edit Subscription"

                :

                "Create Subscription"

              }

            </h2>

            <p>

              Manage client subscription details, pricing and renewal information.

            </p>

          </div>

          <button

            className="modal-close"

            onClick={onClose}

            disabled={saving}

          >

            <X size={20}/>

          </button>

        </div>

        <form

          className="subscription-form"

          onSubmit={handleSubmit}

        >

          <div className="form-grid">

            <div className="form-group">

              <label>

                <User size={15}/>

                Client Name

              </label>

              <input

                type="text"

                value={formData.clientName}

                placeholder="Enter client name"

                onChange={(e)=>

                  updateField(

                    "clientName",

                    e.target.value

                  )

                }

                required

              />

            </div>

            <div className="form-group">

              <label>

                <Layers3 size={15}/>

                Account Type

              </label>

              <select

                value={formData.type}

                onChange={(e)=>

                  updateField(

                    "type",

                    e.target.value

                  )

                }

              >

                <option value="Direct">

                  Direct

                </option>

                <option value="Partner">

                  Partner

                </option>

              </select>

            </div>

          </div>

          <div className="form-group">

            <label>

              <Smartphone size={15}/>

              WhatsApp Username

            </label>

            <input

              type="text"

              placeholder="Enter WhatsApp username"

              value={formData.whatsappUsername}

              onChange={(e)=>

                updateField(

                  "whatsappUsername",

                  e.target.value

                )

              }

            />

          </div>

          <div className="serial-section">

            <div className="serial-header">

              <label>

                Serial Numbers

              </label>

              <button

                type="button"

                className="add-serial-btn"

                onClick={addSerial}

              >

                <Plus size={16}/>

                Add Serial

              </button>

            </div>

            {

              formData.serialNumbers.map(

                (serial,index)=>(

                  <div
                    className="serial-row"
                    key={index}
                  >

                    <input

                      type="text"

                      placeholder="Enter serial number"

                      value={serial}

                      onChange={(e)=>

                        updateSerial(

                          index,

                          e.target.value

                        )

                      }

                    />

                    <button

                      type="button"

                      className="remove-serial-btn"

                      onClick={()=>

                        removeSerial(index)

                      }

                    >

                      <Trash2 size={16}/>

                    </button>

                  </div>

                )

              )

            }

          </div>

          <div className="form-grid">

            <div className="form-group">

              <label>

                <IndianRupee size={15}/>

                Selling Rate

              </label>

              <input

                type="number"

                value={formData.sellingRate}

                onChange={(e)=>

                  updateField(

                    "sellingRate",

                    e.target.value

                  )

                }

              />

            </div>

            <div className="form-group">

              <label>

                <IndianRupee size={15}/>

                Renewal Rate

              </label>

              <input

                type="number"

                value={formData.renewalRate}

                onChange={(e)=>

                  updateField(

                    "renewalRate",

                    e.target.value

                  )

                }

              />

            </div>

          </div>
                    <div className="form-grid">

            <div className="form-group">

              <label>

                <CalendarDays size={15}/>

                Expiry Date

              </label>

              <input

                type="date"

                value={formData.expiryDate}

                onChange={(e)=>

                  updateField(

                    "expiryDate",

                    e.target.value

                  )

                }

                required

              />

            </div>

            <div className="form-group">

              <label>

                <FileText size={15}/>

                Remarks

              </label>

              <textarea

                rows={4}

                placeholder="Additional notes about this subscription..."

                value={formData.remark}

                onChange={(e)=>

                  updateField(

                    "remark",

                    e.target.value

                  )

                }

              />

            </div>

          </div>

          <div className="modal-footer">

            <button

              type="button"

              className="btn-cancel"

              disabled={saving}

              onClick={onClose}

            >

              Cancel

            </button>

            <button

              type="submit"

              className="btn-save"

              disabled={saving}

            >

              {

                saving

                  ?

                  "Saving..."

                  :

                  editingSub

                    ?

                    "Update Subscription"

                    :

                    "Create Subscription"

              }

            </button>

          </div>

        </form>

      </div>

    </div>

  );

}